namespace Solovis.Reports.ReportHelpers.AggregateExposureOverTime {

    export class AggregateExposureOverTimeChartReportGenerator_v2 {

        public static generateReportDefinition() {
            let dataSourceForExposure = {
                name: "exposure",
                path: "/Solovis/Exposure/AggregateExposureOverTime_v2",

                parameterMap: function (parameters, more) {
                    let params: any = {};

                    params.componentSelectionSet = parameters.assetSelectionSet;

                    params.exposureRef = {
                        exposureType: parameters.exposureType
                    };

                    if (parameters.profile) {
                        params.exposureRef.profileId = parameters.profile.id;
                    }

                    if (parameters.tagSet) {
                        params.exposureRef.tagSetIds = parameters.tagSet.map(x => x.tagSetId);
                    }

                    if (parameters.asOfDate) {
                        params.dayId = parameters.asOfDate;
                    }
                    else {
                        params.dayId = InvData.DayId.today();
                    }

                    params.periodLength = parameters.periodLength;
                    params.periodsBack = parameters.periodsBack;

                    if (parameters.targetCurrency) {
                        params.targetCurrencyId = parameters.targetCurrency.id;
                    }

                    params.useBookedValues = parameters.useBookedValues;
                    params.includeTagSet = true;

                    return params;
                },

                postProcess: function (loadedDataSet, more) {

                    let rootNode = null;
                    let runIdToNodeMap: any = {};

                    var modelEnv = new InvData.ModelEnvironment();
                    loadedDataSet.tagSets.forEach((loadedTagSet) => {
                        var tagSet = new InvData.Models.TagSet(loadedTagSet);
                        modelEnv.tagSets.add(tagSet);
                    });

                    $(loadedDataSet.groups).each(function (i, group: any) {
                        let node = {
                            label: null,
                            runId: group.runId,
                            data: group
                        };
                        
                        var label = '';
                        if (group.tags) {
                            for (var i = 2; i <= group.tags.length; i++) {
                                var tag = group.tags[i - 2];
                                var tagSet = modelEnv.tagSets.tryGetById(tag.tagSetId);
                                if (tagSet) {
                                    label += tagSet.tryGetTagById(tag.tagId).label + ' - ';
                                }
                            }
                        }
                        node.label = label + group.label;

                        runIdToNodeMap[node.runId] = node;

                        if (group.parentRunId) {
                            // Parent node will always appear first in result list.
                            let parentNode = runIdToNodeMap[group.parentRunId];
                            if (!parentNode.childNodes) {
                                parentNode.childNodes = [];
                            }

                            parentNode.childNodes.push(node);
                        }
                        else {
                            rootNode = node;
                        }
                    });

                    let dataSet = {
                        originalDataSet: loadedDataSet,
                        modelEnv: modelEnv,
                        rootNode: rootNode
                    };

                    return dataSet;
                }
            };


            const percentFormatter = InvData.FormatterHelper.getPercentageFormatter({ decimalPlaces: 2 });
            const decimalFormatter = InvData.FormatterHelper.getNumberFormatter({ decimalPlaces: 2 });

            var report = {
                fullWidth: true,
                autoSizeSpaceAvailable: true,

                parameters: [
                    {
                        name: "assetSelectionSet", label: "Asset Selection Set", parameterType: "assetSelectionSet",
                        validation: { required: true }
                    },

                    { name: "asOfDate", label: "As Of Date", parameterType: "dateIndex" },

                    {
                        name: "periodLength",
                        label: "Period Length",
                        parameterType: "choice",
                        initialValue: "Month",
                        settings: {
                            options: [
                                { label: "Day", value: "Day" },
                                { label: "Month", value: "Month" },
                                { label: "Quarter", value: "Quarter" },
                                { label: "Year", value: "Year" },
                                { label: "Fiscal Year", value: "FiscalYear" }
                            ]
                        }
                    },

                    { name: "periodsBack", label: "Periods Back", parameterType: "integer" },

                    {
                        name: "profile", label: "Profile", parameterType: "exposureProfile",
                        validation: { required: true }
                    },

                    {
                        name: "tagSet", list: true, label: "Tag Set", parameterType: "tagSet",
                        settings: { dependsOn: { exposureProfile: "profile" } },
                        validation: {
                            required: true,
                        }
                    },

                    {
                        name: "exposureType",
                        label: "Exposure Type",
                        parameterType: "choice",
                        initialValue: "MarketValue",
                        settings: {
                            options: [
                                { label: "Market Value", value: "MarketValue" },
                                { label: "Commitment Amount", value: "CommitmentAmount" }
                            ]
                        }
                    },

                    { name: "targetCurrency", label: "Target Currency", parameterType: "currency" },

                    { name: "useBookedValues", label: "Use Booked Values", parameterType: "bool" },

                    {
                        name: "exposureMeasure", label: "Exposure Measure", parameterType: "choice", initialValue: "Net",
                        settings: {
                            options: [
                                { label: "Long", value: "Long" },
                                { label: "Short", value: "Short" },
                                { label: "Net", value: "Net" },
                                { label: "Gross", value: "Gross" }
                            ]
                        }
                    },

                    {
                        name: "exposureValue", label: "Exposure Value", parameterType: "choice", initialValue: "Percent",
                        settings: {
                            options: [
                                { label: "%", value: "Percent" },
                                { label: "Amount", value: "Amount" }
                            ]
                        }
                    },

                    {
                        name: "chartType", label: "Chart Type", parameterType: "choice", initialValue: "StackedArea",
                        settings: {
                            options: [
                                { label: "Stacked Area", value: "StackedArea" },
                                { label: "Stacked Bar", value: "StackedBar" },
                                { label: "Line", value: "Line" },
                            ]
                        }
                    }
                ],

                root: {
                    elementName: "Root",

                    layout: "Vertical",

                    children: [
                        {
                            partControl: "Solovis.Reports.Parts.HtmlControl",
                            elementName: "ExposureChart",

                            dataSources: [
                                { name: "exposure", ref: { elementName: "Root", dataSourceName: "exposure" } }
                            ],
                            style: { height: "100%" },

                            settings: {
                                render: function () {
                                    if (!this.dataSets.exposure) {
                                        return;
                                    }

                                    let thisReportPart = this;
                                    let exposure = this.dataSets.exposure;

                                    let chartStyle: AggregateExposureChartStyle = {
                                        chartType: this.parameters.chartType,
                                        exposureMeasure: this.parameters.exposureMeasure,
                                        exposureValue: this.parameters.exposureValue
                                    };

                                    // Determine exposure chart persisted settings.
                                    let exposureChartPersistedSettings = null;

                                    let persistedSettingsToUse = this.__exposureChartData ? this.getPersistedSettings() : this.persistedSettings;
                                    if (persistedSettingsToUse) {
                                        exposureChartPersistedSettings = persistedSettingsToUse.exposureChartData;
                                    }

                                    let exposureChartData = new AggregateExposureChartData(exposure, chartStyle, this.parameters, exposureChartPersistedSettings);
                                    this.__exposureChartData = exposureChartData;

                                    if (this.__dxChart) {
                                        this.__dxChart.dispose();
                                        $(this.container).html("");
                                    }

                                    let chartDiv = $("<div>").appendTo(this.container).css("height", "100%");

                                    let chartTitle = this.parameters.exposureMeasure + " Exposure";

                                    let mainValueAxis: any = {
                                        label: {
                                            format: { precision: 0 }
                                        }
                                    };
                                    if (this.parameters.exposureValue === "Percent") {
                                        mainValueAxis.label.format.type = "percent";

                                        chartTitle += " (%)";
                                    }
                                    else {
                                        chartTitle += " (Amount)";
                                    }

                                    let chartOptions: any = {
                                        dataSource: exposureChartData.chartDataSource,
                                        series: exposureChartData.chartSeries,

                                        commonSeriesSettings: {
                                            argumentField: "argValue",
                                            opacity: 1,
                                            point: {
                                                size: 8
                                            }
                                        },

                                        title: {
                                            text: chartTitle
                                        },

                                        argumentAxis: {
                                            visible: true
                                        },

                                        valueAxis: [
                                            mainValueAxis
                                        ],

                                        legend: {
                                            horizontalAlignment: "center",
                                            verticalAlignment: "bottom"
                                        },

                                        panes: [
                                            {}
                                        ],

                                        animation: {
                                            enabled: true
                                        },

                                        export: {
                                            enabled: true
                                        },

                                        onPointHoverChanged: function (e) {
                                            exposureChartData.setLastPointHoverEvent(e);
                                        },

                                        onSeriesHoverChanged: function (e) {
                                            exposureChartData.setLastSeriesHoverEvent(e);
                                        }
                                    };

                                    chartOptions.tooltip = {
                                        enabled: true,
                                        contentTemplate: function (pointInfo, element) {
                                            let tip = element;
                                            $("<div>").text(pointInfo.argumentText).appendTo(tip);
                                            let infoDiv = $("<div>").appendTo(tip);
                                            $("<span>").text(pointInfo.seriesName + ": ").appendTo(infoDiv);

                                            let value = pointInfo.value;
                                            if (Solovis.isNotNull(value)) {
                                                let valueText;
                                                if (thisReportPart.parameters.exposureValue === "Percent") {
                                                    valueText = percentFormatter.format(value);
                                                }
                                                else {
                                                    let currencyCode = exposure.originalDataSet.currencyCode;
                                                    valueText = decimalFormatter.format(value) + " " + currencyCode;
                                                }

                                                $("<span>").text(valueText).appendTo(infoDiv);
                                            }
                                        }
                                    };

                                    if (this.parameters.chartType === "StackedBar") {
                                        chartOptions.barGroupPadding = 0;
                                    }

                                    $(chartDiv).dxChart(chartOptions);

                                    this.__dxChart = $(chartDiv).dxChart("instance");
                                    exposureChartData.setChartInstance(this.__dxChart);

                                    $(chartDiv).bind("contextmenu", function (e) {
                                        e.stopPropagation();

                                        exposureChartData.showContextMenu(e);

                                        return false;
                                    });
                                },

                                getPersistedSettings: function () {
                                    let persistedSettings: any = {};

                                    if (this.__exposureChartData) {
                                        persistedSettings.exposureChartData = this.__exposureChartData.getPersistedSettings();
                                    }

                                    return persistedSettings;
                                }
                            }
                        }
                    ],

                    dataSources: [
                        dataSourceForExposure
                    ]
                }
            };

            return report;
        }
    }

    interface AggregateExposureChartStyle {
        chartType?: "StackedBar" | "Line" | "StackedArea";
        exposureMeasure?: "Long" | "Short" | "Net" | "Gross";
        exposureValue?: "Percent" | "Amount";
    }

    class AggregateExposureChartData {
        private _exposure;
        private _style: AggregateExposureChartStyle;
        private _parameters;

        private _categoryNodes;

        public chartDataSource;
        public chartSeries;

        private _dxChartInstance;
        private _lastPointHoverEvent;
        private _lastSeriesHoverEvent;

        private _fullLabelPathToExpandedMap;

        constructor(exposure, style: AggregateExposureChartStyle, parameters, persistedSettings) {
            this._exposure = exposure;
            this._parameters = parameters;

            this._style = style ? style : {};
            if (!this._style.chartType) {
                this._style.chartType = "Line";
            }
            if (!this._style.exposureMeasure) {
                this._style.exposureMeasure = "Net";
            }
            if (!this._style.exposureValue) {
                this._style.exposureValue = "Percent";
            }

            if (persistedSettings && persistedSettings.fullLabelPathToExpandedMap) {
                this._fullLabelPathToExpandedMap = Solovis.deepCopy(persistedSettings.fullLabelPathToExpandedMap);
            }
            else {
                this._fullLabelPathToExpandedMap = {};
                this._fullLabelPathToExpandedMap["All"] = true;
            }

            this.rebuildChartData();
        }

        public rebuildChartData() {
            let self = this;

            let seriesType;
            switch (this._style.chartType) {
                case "StackedBar": seriesType = "stackedbar"; break;
                case "Line": seriesType = "line"; break;
                
                case "StackedArea":
                default:
                    seriesType = "stackedarea";
                    break;
            }

            let overallByDay = this._exposure.originalDataSet.overallByDay;
            let rootNode = this._exposure.rootNode;

            // Collect categories by traversing tree to the first non-expanded node.
            let categoryNodes = [];

            let collectCategoriesFromNodes = function (node) {
                let fullLabelPath = node.data.fullLabelPath;
                let nodeIsExpanded = !!self._fullLabelPathToExpandedMap[fullLabelPath];

                if (nodeIsExpanded && node.childNodes && node.childNodes.length > 0) {
                    for (let childNode of node.childNodes) {
                        childNode.parentNode = node;
                        collectCategoriesFromNodes(childNode);
                    }
                }
                else {
                    categoryNodes.push(node);
                }
            };

            collectCategoriesFromNodes(rootNode);

            this._categoryNodes = categoryNodes;

            let chartData = [];

            $(overallByDay).each(function (dayIdIndex, overallForDay: any) {
                let chartDataEntry: any = {
                    argValue: InvData.DayId.format(overallForDay.dayId),
                    dayId: overallForDay.dayId,
                };

                let total = overallForDay.overallValue;

                $(categoryNodes).each(function (categoryIndex, categoryNode: any) {
                    let nodeDayEntry = categoryNode.data.byDay[dayIdIndex];

                    let value;
                    switch (self._style.exposureMeasure) {
                        case "Long": value = nodeDayEntry.long; break;
                        case "Short": value = nodeDayEntry.short; break;
                        case "Net": value = nodeDayEntry.long + nodeDayEntry.short; break;
                        case "Gross": value = nodeDayEntry.long - nodeDayEntry.short; break;
                    }

                    if (self._style.exposureValue === "Percent") {
                        value = value / total;
                    }

                    chartDataEntry["value_" + categoryIndex] = value;
                });

                chartData.push(chartDataEntry);
            });

            this.chartDataSource = chartData;

            let pointPalette;
            let seriesList = [];

            $(categoryNodes).each(function (i, categoryNode: any) {
                let seriesEntry = {
                    name: categoryNode.label,
                    type: seriesType,
                    shownInLegend: true,
                    valueField: "value_" + i,
                    nodeLabel: categoryNode.label,
                    nodeFullLabelPath: categoryNode.data.fullLabelPath,
                    nodeParentLabel: categoryNode.parentNode ? categoryNode.parentNode.label : null,
                    nodeParentFullLabelPath: categoryNode.parentNode ? categoryNode.parentNode.data.fullLabelPath : null,
                    hasChildNodes: (categoryNode.childNodes && categoryNode.childNodes.length > 0)
                };
                seriesList.push(seriesEntry);
            });

            if ((window as any).Solovis) {
                let solovisAny = (window as any).Solovis as any;
                if (solovisAny && solovisAny.Custom && solovisAny.Custom.ColorPalette) {
                    pointPalette = solovisAny.Custom.ColorPalette;
                }
            }

            if (pointPalette) {
                let pointPaletteProcessor = new Solovis.Reports.Parts.Tables.PointPaletteProcessor({
                    palette: pointPalette,
                    chartType: self._style.chartType
                });

                self.chartSeries = pointPaletteProcessor
                    ? self.updateSeriesColors(seriesList, pointPaletteProcessor)
                    : seriesList
            }

            if (self._dxChartInstance) {
                self._dxChartInstance.option("dataSource", self.chartDataSource);
                self._dxChartInstance.option("series", self.chartSeries);
                self._dxChartInstance.refresh();
            }

        }

        public updateSeriesColors(seriesList, pointPaletteProcessor) {
            const updatedSeries = (seriesList || [])
                .filter(entry => entry.name && pointPaletteProcessor)
                .map(series => ({
                    ...series,
                    color: pointPaletteProcessor.checkForColor({
                        seriesName: series.name,
                        seriesColorCheck: true
                    })
                }));

            return updatedSeries;
        }

        public setLastPointHoverEvent(e) {
            this._lastPointHoverEvent = e;
            this._lastSeriesHoverEvent = null;
        }

        public setLastSeriesHoverEvent(e) {
            this._lastSeriesHoverEvent = e;
            this._lastPointHoverEvent = null;
        }

        public setChartInstance(dxChartInstance) {
            this._dxChartInstance = dxChartInstance;
        }

        public toggleExpansion(fullLabelPath, expanded) {
            if (expanded) {
                this._fullLabelPathToExpandedMap[fullLabelPath] = true;
            }
            else {
                delete this._fullLabelPathToExpandedMap[fullLabelPath];
            }

            this.rebuildChartData();
        }

        public getPersistedSettings() {
            return {
                fullLabelPathToExpandedMap: Solovis.deepCopy(this._fullLabelPathToExpandedMap)
            };
        }

        public showContextMenu(mouseEvent) {
            let lastHoverData = null;
            let lastSeriesData = null;

            if (this._lastPointHoverEvent && this._lastPointHoverEvent.target) {
                let lastPointHoverTarget = this._lastPointHoverEvent.target;
                lastHoverData = lastPointHoverTarget.data;

                if (lastPointHoverTarget.series && lastPointHoverTarget.series.index >= 0) {
                    lastSeriesData = this.chartSeries[lastPointHoverTarget.series.index];
                }
            }
            else if (this._lastSeriesHoverEvent) {
                if (this._lastSeriesHoverEvent.target && this._lastSeriesHoverEvent.target.index >= 0) {
                    lastSeriesData = this.chartSeries[this._lastSeriesHoverEvent.target.index];
                }
            }

            let dayId = lastHoverData ? lastHoverData.dayId : null;

            let parameters = this._parameters;
            let exposure = this._exposure;

            let links = [];

            if (lastSeriesData != null) {
                if (lastSeriesData.hasChildNodes) {
                    links.push({
                        label: "Expand " + lastSeriesData.nodeLabel,
                        click: () => {
                            this.toggleExpansion(lastSeriesData.nodeFullLabelPath, true);
                        }
                    });
                }

                if (lastSeriesData.nodeParentFullLabelPath) {
                    links.push({
                        label: "Collapse " + lastSeriesData.nodeParentLabel,
                        click: () => {
                            this.toggleExpansion(lastSeriesData.nodeParentFullLabelPath, false);
                        }
                    });
                }

                links.push({ separator: true });
            }

            let rollUpLink = Solovis.Reports.ReportHelpers.AggregateExposureOverTime.
                AggregateExposureOverTimeReportGenerator_v2.createLinkToRollUpReport(exposure.modelEnv, parameters, dayId);

            // Aggregate Exposure Over Time
            let reportCodeForAggregateExposureOverTime = "9B5E2FA7-BAD4-4722-8294-9C69D1FF6AF8";
            let aggExpParams = Solovis.Reports.ReportHelpers.AggregateExposureOverTime.
                AggregateExposureOverTimeReportGenerator_v2.copyCoreAggregateExposureParameters(parameters);
            let aggExpUrl = Solovis.Reports.ReportLinker.getReportLink({
                reportCode: reportCodeForAggregateExposureOverTime,
                parameters: aggExpParams,
                autoRun: true
            });
            let aggExpLabel = "Aggregate Exposure Over Time (Table)";

            links.push(rollUpLink);

            links.push({
                label: aggExpLabel,
                href: aggExpUrl
            });

            Solovis.UI.PopupLinkPanel.showLinks({
                links: links,
                offset: mouseEvent
            });
        }
    }
}